/**
 * ****************************
 * GlobalNav Routes *
 * ****************************
 */
import dashboard from '@/router/dashboard.js';
import archiveSearch from '@/router/archiveSearch/index';
import configuration from '@/router/configuration/index';
import discoveryTool from '@/router/discoveryTool/index';
import platformAdmin from '@/router/platformAdmin';
import emailGateway from '@/router/emailGateway/index';
import gettingStarted from '../router/gettingStarted';
import { NotFoundWildCard, NotFound404 } from '../router/NotFound';
import expirePlan from '../router/expirePlan';

/**
 * ************
 * SSO Routes Components*
 * ************
 */
const SuccessSSO = () => import('@/components/SSO/SuccessWindow');
const FailureSSO = () => import('@/components/SSO/FailureWindow');
const AzureSSO = () => import('@/components/SSO/AzureSSO');
const CallbackSSO = () => import('@/components/SSO/CallbackWindow');

/**
 * **************
 * Other Routes Components *
 * **************
 */
const ServiceStatus = () => import('@/components/ServiceStatus');
const Loader = () => import('@/components/Common/FullWidthLoader.vue');

let menuRoutes = [
  { path: '/', component: Loader },

  {
    path: '/service-status',
    component: ServiceStatus,
    meta: {
      noMenuItems: true
    }
  },
  expirePlan,
  gettingStarted,
  NotFound404,
  {
    path: '/connector',
    component: AzureSSO,
    meta: {
      type: 'sso'
    },
    children: [
      {
        path: 'callback',
        component: CallbackSSO,
        meta: { type: 'sso' }
      },
      {
        path: 'success',
        component: SuccessSSO,
        meta: { type: 'sso' }
      },
      {
        path: 'failure',
        component: FailureSSO,
        meta: { type: 'sso' }
      }
    ]
  },

  dashboard,
  archiveSearch,
  configuration,
  discoveryTool,
  platformAdmin,
  emailGateway,
  NotFoundWildCard
];

export default menuRoutes;
